import type { Request } from './contracts';

/** Quotes depend on output settings and reference media, not the text or canvas target. */
export function generationPriceKey(request: Request | null): string {
  return request ? JSON.stringify({ kind: request.kind, model: request.model, quantity: request.quantity,
    inputs: request.inputs, references: request.references.map(reference => request.video ? { source: reference.element || reference.mediaAssetId || reference.url, role: reference.role || reference.mediaKind || 'image' } : reference.element || reference.mediaAssetId || reference.url) }) : '';
}

export function generationQuote(request: Request): Request {
  // Destination access is checked when starting the run, after the canvas has synced.
  return { ...request, prompt: '', destination: undefined };
}
